/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BrandEdit_brand$ref = any;
export type UpdateStoreInput = {|
  billingAddress?: ?string,
  birthdayCashbackRate?: ?number,
  categoryIds?: ?$ReadOnlyArray<string>,
  clientMutationId?: ?string,
  customerServiceEmail?: ?string,
  defaultCashbackRate?: ?number,
  email?: ?string,
  fastCashEnabled?: ?boolean,
  id: string,
  isFeatured?: ?boolean,
  merchantName?: ?string,
  name: string,
  normalClosingHour?: ?number,
  normalOpeningHour?: ?number,
  phoneNumber: string,
  storeNumber?: ?string,
  sundayClosingHour?: ?number,
  sundayOpeningHour?: ?number,
  uniqueInState?: ?boolean,
|};
export type updateStoreMutationVariables = {|
  input: UpdateStoreInput
|};
export type updateStoreMutationResponse = {|
  +updateStore: ?{|
    +store: ?{|
      +$fragmentRefs: BrandEdit_brand$ref
    |},
    +errors: ?$ReadOnlyArray<{|
      +key: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
  |}
|};
export type updateStoreMutation = {|
  variables: updateStoreMutationVariables,
  response: updateStoreMutationResponse,
|};
*/


/*
mutation updateStoreMutation(
  $input: UpdateStoreInput!
) {
  updateStore(input: $input) {
    store {
      ...BrandEdit_brand
      id
    }
    errors {
      key
      messages
    }
  }
}

fragment BrandEdit_brand on Store {
  id
  name
  phoneNumber
  email
  storeNumber
  defaultCashbackRate
  birthdayCashbackRate
  uniqueInState
  fastCashEnabled
  normalOpeningHour
  normalClosingHour
  sundayOpeningHour
  sundayClosingHour
  customerServiceEmail
  isFeatured
  logoUrl
  imageUrl
  locationMapUrl
  billingAddress
  state
  categories {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateStoreInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messages",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateStoreMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateStorePayload",
        "kind": "LinkedField",
        "name": "updateStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BrandEdit_brand"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateStoreMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateStorePayload",
        "kind": "LinkedField",
        "name": "updateStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "storeNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultCashbackRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "birthdayCashbackRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uniqueInState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fastCashEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "normalOpeningHour",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "normalClosingHour",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sundayOpeningHour",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sundayClosingHour",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerServiceEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFeatured",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locationMapUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingAddress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Category",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateStoreMutation",
    "operationKind": "mutation",
    "text": "mutation updateStoreMutation(\n  $input: UpdateStoreInput!\n) {\n  updateStore(input: $input) {\n    store {\n      ...BrandEdit_brand\n      id\n    }\n    errors {\n      key\n      messages\n    }\n  }\n}\n\nfragment BrandEdit_brand on Store {\n  id\n  name\n  phoneNumber\n  email\n  storeNumber\n  defaultCashbackRate\n  birthdayCashbackRate\n  uniqueInState\n  fastCashEnabled\n  normalOpeningHour\n  normalClosingHour\n  sundayOpeningHour\n  sundayClosingHour\n  customerServiceEmail\n  isFeatured\n  logoUrl\n  imageUrl\n  locationMapUrl\n  billingAddress\n  state\n  categories {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '487efb7542970d9e3a549c6faba23e7e';

module.exports = node;
